export default "__VITE_ASSET__rhdmkUzL__"